import {FOOTER} from "../../constants/footer";

export function setFooterOffset(data) {
  return {
    type: FOOTER.SET_OFFSET_LEFT.MAIN,
    data
  }
}
